import React, { useState } from 'react';
import { ReactComponent as BackIcon } from "../../assets/icons/iconBack.svg";
import { ReactComponent as NextIcon } from "../../assets/icons/iconNext.svg";

import './PhotoCarousel.scss';

const PhotoCarousel = ({ worksImgs }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((currentIndex + 1) % worksImgs.length);
  };

  const handlePrev = () => {
    setCurrentIndex((currentIndex - 1 + worksImgs.length) % worksImgs.length);
  };

  return (
    <div className="photo-Carousel">
      
      <BackIcon  onClick={handlePrev} className="prev" title="Back review" aria-label="Back review" />
      <div className="image-section">
        <img src={worksImgs[currentIndex].image} alt={worksImgs[currentIndex].alt} />
      </div>
      <NextIcon  onClick={handleNext} className="next" title="Next review" aria-label="Next review" />
    </div>
  );
};

export default PhotoCarousel;
